// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".roll-border{stroke:#00ff29}.roll-text{fill:#00ff29}.roll-button{pointer-events:all;cursor:pointer}.roll-button.unlocked{pointer-events:none}.cursor-symbol{fill:#00ff29}.roll-button .cursor-frame{fill:rgba(0,255,41,.30196078431372547)}.roll-button.unlocked .cursor-frame,.roll-button:hover .cursor-frame{fill:#00ff29}.roll-button.unlocked .cursor-symbol,.roll-button:hover .cursor-symbol{fill:#000}", ""]);
// Exports
module.exports = exports;
